module.exports = __webpack_public_path__ + "img/big_1_41.c4a51444.png";